export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_DEFAULT_3.0b783ec7.jpg";